import "./ReleaseLogs.css";
import PageDependencies from "../../../Feature/PageDependencies";

const ReleaseLog = (props) => {
    const {
        guid
    } = PageDependencies();

    const item = props.item;
    if(item === undefined) return <></>;
    return (
        <div className="main-card mb-3 card">
            <div className="card-header">
                <p><strong>Version:</strong> {item.softwareVersion}&nbsp;&nbsp;&nbsp;</p>
                <p><strong></strong> {item.chenathEngineVersionsString}&nbsp;&nbsp;&nbsp;</p>
                <p><strong>Release Date:</strong> {item.releaseDateString}</p>
            </div>
            <div className="card-body">  
            {item.newFeatures.length > 0 &&
                <div>
                    <div className="section-title">New Features</div>
                    <ul>
                        {item.newFeatures.map(i=>{
                            return <li key = {guid.newGuid()}>{i.appliedVersionsString}{i.content}</li>    
                        })}
                    </ul>
                </div>
            }
            {item.bugFixes.length > 0 &&
                <div>
                    <div className="section-title">Bug fixes</div>
                    <ul>
                        {item.bugFixes.map(i=>{
                            return <li key = {guid.newGuid()}>{i.appliedVersionsString}{i.content}</li>  
                        })}
                    </ul>
                </div>
            }
            {item.improvements.length > 0 &&
                <div>
                    <div className="section-title">Improvements</div>
                    <ul>
                        {item.improvements.map(i=>{
                           return <li key = {guid.newGuid()}>{i.appliedVersionsString}{i.content}</li>  
                        })}
                    </ul>
                </div>
            }
            {item.nextSteps.length > 0 &&
                <div>
                    <div className="section-title">What's Next</div>
                    <ul>
                        {item.nextSteps.map(i=>{
                           return <li key = {guid.newGuid()}>{i.appliedVersionsString}{i.content}</li>  
                        })}
                    </ul>
                </div>
            }
            </div>
        </div>)
}

export default ReleaseLog;